<template>
  <div>
    <b-modal v-model="showModal" hide-header hide-footer centered>
      <div>
        <InputText
          v-model="formData.prefix"
          :textFloat="'คำนำหน้า'"
          :placeholder="'กรุณาระบุคำนำหน้า'"
          type="text"
          name="prefix"
          @onKeypress="isEngLetters($event)"
          @onPaste="handlePaste($event)"
        />
        <!-- @input="isEngLetters($event)" -->
        <InputText
          v-model="formData.amount"
          :textFloat="'จำนวนโค้ด'"
          :placeholder="'กรุณาระบุจำนวนโค้ด'"
          type="text"
          name="amountCode"
          @onKeypress="isNumber($event)"
          :isValidate="$v.formData.amount.$error"
          :v="$v.formData.amount"
        />
        <div class="error-message">
          <span>{{ error }}</span>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-4">
        <b-button class="button btn-cancel mr-2" @click="hide"
          >ย้อนกลับ</b-button
        >
        <b-button
          class="btn-main"
          @click="confirm"
          :disabled="!formData.prefix || !formData.amount"
          >ยืนยัน</b-button
        >
      </div>
    </b-modal>
    <ModalHistoryCode
      ref="modalHistoryCode"
      :couponList="formData.couponList"
      :prefixCode="formData.prefix"
    />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import axios from "axios";
import InputText from "@/components/inputs/InputText";
import ModalHistoryCode from "@/views/pages/promotion/components/ModalHistoryCode";
import ModalLoading from "@/components/modal/alert/ModalLoading";

import { minValue } from "vuelidate/lib/validators";

export default {
  components: {
    InputText,
    ModalHistoryCode,
    ModalLoading
  },
  data() {
    return {
      showModal: false,
      formData: {
        prefix: "",
        amount: "",
        couponList: [],
      },
      error: "",
    };
  },
  validations() {
    return {
      formData: {
        amount: {
          minValue: minValue(1),
        },
      },
    };
  },
  methods: {
    show() {
      this.showModal = true;
      this.formData = {};
    },
    hide() {
      this.showModal = false;
    },
    confirm() {
      this.$v.formData.$touch();
      if (this.$v.formData.$error) return;
      this.$refs.modalLoading.show();
      axios({
        url: `${this.$baseUrl}/api/Coupon/Generate`,
        method: "POST",
        headers: this.$headers,
        data: {
          prefix: this.formData.prefix,
          quantity: Number(this.formData.amount),
          encodedReference: "",
        },
        validateStatus: () => true,
      })
        .then((response) => {
          this.$refs.modalLoading.hide();
          if (response.data.result == 1) {
            this.formData.couponList = response.data.detail.coupons;
            this.showModal = false;
            this.$refs.modalHistoryCode.show();
            this.$emit("handleData", this.formData);
          } else {
            this.error = response.data.detail.replace("Forbidden: ", "");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isEngLetters: function (evt) {
      const isLetter = /^[A-Za-z]$/.test(evt.key);
      if (!isLetter) {
        evt.preventDefault();
      }
    },
    handlePaste: function (event) {
      const text = event.clipboardData.getData("text");
      if (!/^[A-Za-z]+$/.test(text)) {
        event.preventDefault();
      }
    },
  },
  watch: {
    "formData.prefix": function () {
      this.error = "";
    },
  }
};
</script>

<style lang="scss" scoped>
.error-message {
  color: red;
  font-size: 12px;
  position: relative;
  top: -10px;
  height: 5px;
}
</style>
